/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import React from 'react';
import Loadable from 'react-loadable';
const AddToCalendar = Loadable({
  loader: () => import(/* webpackChunkName: "AddToCalendar" */ '../global/containers/common/AddToCalendar'),
  webpack: () => [require.resolveWeak('../global/containers/common/AddToCalendar')],
  loading: () => <span/>,
  modules: ['AddToCalendar'],
  });
const Article = Loadable({
  loader: () => import(/* webpackChunkName: "Article" */ '../global/containers/common/Article'),
  webpack: () => [require.resolveWeak('../global/containers/common/Article')],
  loading: () => <span/>,
  modules: ['Article'],
  });
const BannerSupergraphic = Loadable({
  loader: () => import(/* webpackChunkName: "BannerSupergraphic" */ '../global/containers/common/BannerSupergraphic'),
  webpack: () => [require.resolveWeak('../global/containers/common/BannerSupergraphic')],
  loading: () => <span/>,
  modules: ['BannerSupergraphic'],
  });
const BoxOverlayImage = Loadable({
  loader: () => import(/* webpackChunkName: "BoxOverlayImage" */ '../global/containers/common/BoxOverlayImage'),
  webpack: () => [require.resolveWeak('../global/containers/common/BoxOverlayImage')],
  loading: () => <span/>,
  modules: ['BoxOverlayImage'],
  });
const BranchesMap = Loadable({
  loader: () => import(/* webpackChunkName: "BranchesMap" */ '../global/containers/common/BranchesMap'),
  webpack: () => [require.resolveWeak('../global/containers/common/BranchesMap')],
  loading: () => <span/>,
  modules: ['BranchesMap'],
  });
const Breadcrumb = Loadable({
  loader: () => import(/* webpackChunkName: "Breadcrumb" */ '../global/containers/common/Breadcrumb'),
  webpack: () => [require.resolveWeak('../global/containers/common/Breadcrumb')],
  loading: () => <span/>,
  modules: ['Breadcrumb'],
  });
const BusinessFacility = Loadable({
  loader: () => import(/* webpackChunkName: "BusinessFacility" */ '../global/containers/common/BusinessFacility'),
  webpack: () => [require.resolveWeak('../global/containers/common/BusinessFacility')],
  loading: () => <span/>,
  modules: ['BusinessFacility'],
  });
const CategoryListing = Loadable({
  loader: () => import(/* webpackChunkName: "CategoryListing" */ '../global/containers/common/CategoryListing'),
  webpack: () => [require.resolveWeak('../global/containers/common/CategoryListing')],
  loading: () => <span/>,
  modules: ['CategoryListing'],
  });
const CollageType1 = Loadable({
  loader: () => import(/* webpackChunkName: "CollageType1" */ '../global/containers/common/CollageType1'),
  webpack: () => [require.resolveWeak('../global/containers/common/CollageType1')],
  loading: () => <span/>,
  modules: ['CollageType1'],
  });
const CollageType2 = Loadable({
  loader: () => import(/* webpackChunkName: "CollageType2" */ '../global/containers/common/CollageType2'),
  webpack: () => [require.resolveWeak('../global/containers/common/CollageType2')],
  loading: () => <span/>,
  modules: ['CollageType2'],
  });
const CompanyLocations = Loadable({
  loader: () => import(/* webpackChunkName: "CompanyLocations" */ '../global/containers/common/CompanyLocations'),
  webpack: () => [require.resolveWeak('../global/containers/common/CompanyLocations')],
  loading: () => <span/>,
  modules: ['CompanyLocations'],
  });
const ConfigurableTimer = Loadable({
  loader: () => import(/* webpackChunkName: "ConfigurableTimer" */ '../global/containers/common/ConfigurableTimer'),
  webpack: () => [require.resolveWeak('../global/containers/common/ConfigurableTimer')],
  loading: () => <span/>,
  modules: ['ConfigurableTimer'],
  });
const CookieConsent = Loadable({
  loader: () => import(/* webpackChunkName: "CookieConsent" */ '../global/containers/common/CookieConsent'),
  webpack: () => [require.resolveWeak('../global/containers/common/CookieConsent')],
  loading: () => <span/>,
  modules: ['CookieConsent'],
  });
const CurrentWeather = Loadable({
  loader: () => import(/* webpackChunkName: "CurrentWeather" */ '../global/containers/common/CurrentWeather'),
  webpack: () => [require.resolveWeak('../global/containers/common/CurrentWeather')],
  loading: () => <span/>,
  modules: ['CurrentWeather'],
  });
const DayHighlight = Loadable({
  loader: () => import(/* webpackChunkName: "DayHighlight" */ '../global/containers/common/DayHighlight'),
  webpack: () => [require.resolveWeak('../global/containers/common/DayHighlight')],
  loading: () => <span/>,
  modules: ['DayHighlight'],
  });
const DetailedDescription = Loadable({
  loader: () => import(/* webpackChunkName: "DetailedDescription" */ '../global/containers/common/DetailedDescription'),
  webpack: () => [require.resolveWeak('../global/containers/common/DetailedDescription')],
  loading: () => <span/>,
  modules: ['DetailedDescription'],
  });
const DualHeroSlider = Loadable({
  loader: () => import(/* webpackChunkName: "DualHeroSlider" */ '../global/containers/common/DualHeroSlider'),
  webpack: () => [require.resolveWeak('../global/containers/common/DualHeroSlider')],
  loading: () => <span/>,
  modules: ['DualHeroSlider'],
  });
const EditorialGrid = Loadable({
  loader: () => import(/* webpackChunkName: "EditorialGrid" */ '../global/containers/common/EditorialGrid'),
  webpack: () => [require.resolveWeak('../global/containers/common/EditorialGrid')],
  loading: () => <span/>,
  modules: ['EditorialGrid'],
  });
const EditorialText = Loadable({
  loader: () => import(/* webpackChunkName: "EditorialText" */ '../global/containers/common/EditorialText'),
  webpack: () => [require.resolveWeak('../global/containers/common/EditorialText')],
  loading: () => <span/>,
  modules: ['EditorialText'],
  });
const EventDetails = Loadable({
  loader: () => import(/* webpackChunkName: "EventDetails" */ '../global/containers/common/EventDetails'),
  webpack: () => [require.resolveWeak('../global/containers/common/EventDetails')],
  loading: () => <span/>,
  modules: ['EventDetails'],
  });
const ExploreHotels = Loadable({
  loader: () => import(/* webpackChunkName: "ExploreHotels" */ '../global/containers/common/ExploreHotels'),
  webpack: () => [require.resolveWeak('../global/containers/common/ExploreHotels')],
  loading: () => <span/>,
  modules: ['ExploreHotels'],
  });
const ExploreMap = Loadable({
  loader: () => import(/* webpackChunkName: "ExploreMap" */ '../global/containers/common/ExploreMap'),
  webpack: () => [require.resolveWeak('../global/containers/common/ExploreMap')],
  loading: () => <span/>,
  modules: ['ExploreMap'],
  });
const FaqAccordion = Loadable({
  loader: () => import(/* webpackChunkName: "FaqAccordion" */ '../global/containers/common/FaqAccordion'),
  webpack: () => [require.resolveWeak('../global/containers/common/FaqAccordion')],
  loading: () => <span/>,
  modules: ['FaqAccordion'],
  });
const FavoriteSubLayout = Loadable({
  loader: () => import(/* webpackChunkName: "FavoriteSubLayout" */ '../global/containers/common/FavoriteSubLayout'),
  webpack: () => [require.resolveWeak('../global/containers/common/FavoriteSubLayout')],
  loading: () => <span/>,
  modules: ['FavoriteSubLayout'],
  });
const FilteredList = Loadable({
  loader: () => import(/* webpackChunkName: "FilteredList" */ '../global/containers/common/FilteredList'),
  webpack: () => [require.resolveWeak('../global/containers/common/FilteredList')],
  loading: () => <span/>,
  modules: ['FilteredList'],
  });
const Filters = Loadable({
  loader: () => import(/* webpackChunkName: "Filters" */ '../global/containers/common/Filters'),
  webpack: () => [require.resolveWeak('../global/containers/common/Filters')],
  loading: () => <span/>,
  modules: ['Filters'],
  });
const FlexiVisual = Loadable({
  loader: () => import(/* webpackChunkName: "FlexiVisual" */ '../global/containers/common/FlexiVisual'),
  webpack: () => [require.resolveWeak('../global/containers/common/FlexiVisual')],
  loading: () => <span/>,
  modules: ['FlexiVisual'],
  });
const Footer = Loadable({
  loader: () => import(/* webpackChunkName: "Footer" */ '../global/containers/common/Footer'),
  webpack: () => [require.resolveWeak('../global/containers/common/Footer')],
  loading: () => <span/>,
  modules: ['Footer'],
  });
const Form = Loadable({
  loader: () => import(/* webpackChunkName: "Form" */ '../global/containers/common/Form'),
  webpack: () => [require.resolveWeak('../global/containers/common/Form')],
  loading: () => <span/>,
  modules: ['Form'],
  });
const FormCollection = Loadable({
  loader: () => import(/* webpackChunkName: "FormCollection" */ '../global/containers/common/FormCollection'),
  webpack: () => [require.resolveWeak('../global/containers/common/FormCollection')],
  loading: () => <span/>,
  modules: ['FormCollection'],
  });
const GenericMap = Loadable({
  loader: () => import(/* webpackChunkName: "GenericMap" */ '../global/containers/common/GenericMap'),
  webpack: () => [require.resolveWeak('../global/containers/common/GenericMap')],
  loading: () => <span/>,
  modules: ['GenericMap'],
  });
const GlobalSearchSubLayout = Loadable({
  loader: () => import(/* webpackChunkName: "GlobalSearchSubLayout" */ '../global/containers/common/GlobalSearchSubLayout'),
  webpack: () => [require.resolveWeak('../global/containers/common/GlobalSearchSubLayout')],
  loading: () => <span/>,
  modules: ['GlobalSearchSubLayout'],
  });
const HappinessWidget = Loadable({
  loader: () => import(/* webpackChunkName: "HappinessWidget" */ '../global/containers/common/HappinessWidget'),
  webpack: () => [require.resolveWeak('../global/containers/common/HappinessWidget')],
  loading: () => <span/>,
  modules: ['HappinessWidget'],
  });
const Header = Loadable({
  loader: () => import(/* webpackChunkName: "Header" */ '../global/containers/common/Header'),
  webpack: () => [require.resolveWeak('../global/containers/common/Header')],
  loading: () => <span/>,
  modules: ['Header'],
  });
const HeroBannerSupergraphic = Loadable({
  loader: () => import(/* webpackChunkName: "HeroBannerSupergraphic" */ '../global/containers/common/HeroBannerSupergraphic'),
  webpack: () => [require.resolveWeak('../global/containers/common/HeroBannerSupergraphic')],
  loading: () => <span/>,
  modules: ['HeroBannerSupergraphic'],
  });
const HeroCarousel = Loadable({
  loader: () => import(/* webpackChunkName: "HeroCarousel" */ '../global/containers/common/HeroCarousel'),
  webpack: () => [require.resolveWeak('../global/containers/common/HeroCarousel')],
  loading: () => <span/>,
  modules: ['HeroCarousel'],
  });
const Infobox = Loadable({
  loader: () => import(/* webpackChunkName: "Infobox" */ '../global/containers/common/Infobox'),
  webpack: () => [require.resolveWeak('../global/containers/common/Infobox')],
  loading: () => <span/>,
  modules: ['Infobox'],
  });
const ItineraryMap = Loadable({
  loader: () => import(/* webpackChunkName: "ItineraryMap" */ '../global/containers/common/ItineraryMap'),
  webpack: () => [require.resolveWeak('../global/containers/common/ItineraryMap')],
  loading: () => <span/>,
  modules: ['ItineraryMap'],
  });
const ListingSubLayout = Loadable({
  loader: () => import(/* webpackChunkName: "ListingSubLayout" */ '../global/containers/common/ListingSubLayout'),
  webpack: () => [require.resolveWeak('../global/containers/common/ListingSubLayout')],
  loading: () => <span/>,
  modules: ['ListingSubLayout'],
  });
const MarketingMessage = Loadable({
  loader: () => import(/* webpackChunkName: "MarketingMessage" */ '../global/containers/common/MarketingMessage'),
  webpack: () => [require.resolveWeak('../global/containers/common/MarketingMessage')],
  loading: () => <span/>,
  modules: ['MarketingMessage'],
  });
const MediaGallery = Loadable({
  loader: () => import(/* webpackChunkName: "MediaGallery" */ '../global/containers/common/MediaGallery'),
  webpack: () => [require.resolveWeak('../global/containers/common/MediaGallery')],
  loading: () => <span/>,
  modules: ['MediaGallery'],
  });
const MegaNav = Loadable({
  loader: () => import(/* webpackChunkName: "MegaNav" */ '../global/containers/common/MegaNav'),
  webpack: () => [require.resolveWeak('../global/containers/common/MegaNav')],
  loading: () => <span/>,
  modules: ['MegaNav'],
  });
const MultiCardCarousel = Loadable({
  loader: () => import(/* webpackChunkName: "MultiCardCarousel" */ '../global/containers/common/MultiCardCarousel'),
  webpack: () => [require.resolveWeak('../global/containers/common/MultiCardCarousel')],
  loading: () => <span/>,
  modules: ['MultiCardCarousel'],
  });
const NoFavoriteFound = Loadable({
  loader: () => import(/* webpackChunkName: "NoFavoriteFound" */ '../global/containers/common/NoFavoriteFound'),
  webpack: () => [require.resolveWeak('../global/containers/common/NoFavoriteFound')],
  loading: () => <span/>,
  modules: ['NoFavoriteFound'],
  });
const NoSearchResult = Loadable({
  loader: () => import(/* webpackChunkName: "NoSearchResult" */ '../global/containers/common/NoSearchResult'),
  webpack: () => [require.resolveWeak('../global/containers/common/NoSearchResult')],
  loading: () => <span/>,
  modules: ['NoSearchResult'],
  });
const Notification = Loadable({
  loader: () => import(/* webpackChunkName: "Notification" */ '../global/containers/common/Notification'),
  webpack: () => [require.resolveWeak('../global/containers/common/Notification')],
  loading: () => <span/>,
  modules: ['Notification'],
  });
const OperatingHours = Loadable({
  loader: () => import(/* webpackChunkName: "OperatingHours" */ '../global/containers/common/OperatingHours'),
  webpack: () => [require.resolveWeak('../global/containers/common/OperatingHours')],
  loading: () => <span/>,
  modules: ['OperatingHours'],
  });
const OurRecommendation = Loadable({
  loader: () => import(/* webpackChunkName: "OurRecommendation" */ '../global/containers/common/OurRecommendation'),
  webpack: () => [require.resolveWeak('../global/containers/common/OurRecommendation')],
  loading: () => <span/>,
  modules: ['OurRecommendation'],
  });
const PageHeading = Loadable({
  loader: () => import(/* webpackChunkName: "PageHeading" */ '../global/containers/common/PageHeading'),
  webpack: () => [require.resolveWeak('../global/containers/common/PageHeading')],
  loading: () => <span/>,
  modules: ['PageHeading'],
  });
const PillarsCarousel = Loadable({
  loader: () => import(/* webpackChunkName: "PillarsCarousel" */ '../global/containers/common/PillarsCarousel'),
  webpack: () => [require.resolveWeak('../global/containers/common/PillarsCarousel')],
  loading: () => <span/>,
  modules: ['PillarsCarousel'],
  });
const PrivacyPolicy = Loadable({
  loader: () => import(/* webpackChunkName: "PrivacyPolicy" */ '../global/containers/common/PrivacyPolicy'),
  webpack: () => [require.resolveWeak('../global/containers/common/PrivacyPolicy')],
  loading: () => <span/>,
  modules: ['PrivacyPolicy'],
  });
const Quote = Loadable({
  loader: () => import(/* webpackChunkName: "Quote" */ '../global/containers/common/Quote'),
  webpack: () => [require.resolveWeak('../global/containers/common/Quote')],
  loading: () => <span/>,
  modules: ['Quote'],
  });
const QuotesCarousel = Loadable({
  loader: () => import(/* webpackChunkName: "QuotesCarousel" */ '../global/containers/common/QuotesCarousel'),
  webpack: () => [require.resolveWeak('../global/containers/common/QuotesCarousel')],
  loading: () => <span/>,
  modules: ['QuotesCarousel'],
  });
const RegionsMap = Loadable({
  loader: () => import(/* webpackChunkName: "RegionsMap" */ '../global/containers/common/RegionsMap'),
  webpack: () => [require.resolveWeak('../global/containers/common/RegionsMap')],
  loading: () => <span/>,
  modules: ['RegionsMap'],
  });
const RequestForProposal = Loadable({
  loader: () => import(/* webpackChunkName: "RequestForProposal" */ '../global/containers/common/RequestForProposal'),
  webpack: () => [require.resolveWeak('../global/containers/common/RequestForProposal')],
  loading: () => <span/>,
  modules: ['RequestForProposal'],
  });
const ResponsiveCollage = Loadable({
  loader: () => import(/* webpackChunkName: "ResponsiveCollage" */ '../global/containers/common/ResponsiveCollage'),
  webpack: () => [require.resolveWeak('../global/containers/common/ResponsiveCollage')],
  loading: () => <span/>,
  modules: ['ResponsiveCollage'],
  });
const ScheduleData = Loadable({
  loader: () => import(/* webpackChunkName: "ScheduleData" */ '../global/containers/common/ScheduleData'),
  webpack: () => [require.resolveWeak('../global/containers/common/ScheduleData')],
  loading: () => <span/>,
  modules: ['ScheduleData'],
  });
const Search = Loadable({
  loader: () => import(/* webpackChunkName: "Search" */ '../global/containers/common/Search'),
  webpack: () => [require.resolveWeak('../global/containers/common/Search')],
  loading: () => <span/>,
  modules: ['Search'],
  });
const SearchBar = Loadable({
  loader: () => import(/* webpackChunkName: "SearchBar" */ '../global/containers/common/SearchBar'),
  webpack: () => [require.resolveWeak('../global/containers/common/SearchBar')],
  loading: () => <span/>,
  modules: ['SearchBar'],
  });
const SimilarSearch = Loadable({
  loader: () => import(/* webpackChunkName: "SimilarSearch" */ '../global/containers/common/SimilarSearch'),
  webpack: () => [require.resolveWeak('../global/containers/common/SimilarSearch')],
  loading: () => <span/>,
  modules: ['SimilarSearch'],
  });
const SingleSlideCarousel = Loadable({
  loader: () => import(/* webpackChunkName: "SingleSlideCarousel" */ '../global/containers/common/SingleSlideCarousel'),
  webpack: () => [require.resolveWeak('../global/containers/common/SingleSlideCarousel')],
  loading: () => <span/>,
  modules: ['SingleSlideCarousel'],
  });
const Sitemap = Loadable({
  loader: () => import(/* webpackChunkName: "Sitemap" */ '../global/containers/common/Sitemap'),
  webpack: () => [require.resolveWeak('../global/containers/common/Sitemap')],
  loading: () => <span/>,
  modules: ['Sitemap'],
  });
const SmartList = Loadable({
  loader: () => import(/* webpackChunkName: "SmartList" */ '../global/containers/common/SmartList'),
  webpack: () => [require.resolveWeak('../global/containers/common/SmartList')],
  loading: () => <span/>,
  modules: ['SmartList'],
  });
const SocialShare = Loadable({
  loader: () => import(/* webpackChunkName: "SocialShare" */ '../global/containers/common/SocialShare'),
  webpack: () => [require.resolveWeak('../global/containers/common/SocialShare')],
  loading: () => <span/>,
  modules: ['SocialShare'],
  });
const SponsorGrid = Loadable({
  loader: () => import(/* webpackChunkName: "SponsorGrid" */ '../global/containers/common/SponsorGrid'),
  webpack: () => [require.resolveWeak('../global/containers/common/SponsorGrid')],
  loading: () => <span/>,
  modules: ['SponsorGrid'],
  });
const StickyTitle = Loadable({
  loader: () => import(/* webpackChunkName: "StickyTitle" */ '../global/containers/common/StickyTitle'),
  webpack: () => [require.resolveWeak('../global/containers/common/StickyTitle')],
  loading: () => <span/>,
  modules: ['StickyTitle'],
  });
const SubNavigation = Loadable({
  loader: () => import(/* webpackChunkName: "SubNavigation" */ '../global/containers/common/SubNavigation'),
  webpack: () => [require.resolveWeak('../global/containers/common/SubNavigation')],
  loading: () => <span/>,
  modules: ['SubNavigation'],
  });
const TabsWithArticle1 = Loadable({
  loader: () => import(/* webpackChunkName: "TabsWithArticle1" */ '../global/containers/common/TabsWithArticle1'),
  webpack: () => [require.resolveWeak('../global/containers/common/TabsWithArticle1')],
  loading: () => <span/>,
  modules: ['TabsWithArticle1'],
  });
const TabsWithCollage = Loadable({
  loader: () => import(/* webpackChunkName: "TabsWithCollage" */ '../global/containers/common/TabsWithCollage'),
  webpack: () => [require.resolveWeak('../global/containers/common/TabsWithCollage')],
  loading: () => <span/>,
  modules: ['TabsWithCollage'],
  });
const TabsWithForm = Loadable({
  loader: () => import(/* webpackChunkName: "TabsWithForm" */ '../global/containers/common/TabsWithForm'),
  webpack: () => [require.resolveWeak('../global/containers/common/TabsWithForm')],
  loading: () => <span/>,
  modules: ['TabsWithForm'],
  });
const TermsAndCondition = Loadable({
  loader: () => import(/* webpackChunkName: "TermsAndCondition" */ '../global/containers/common/TermsAndCondition'),
  webpack: () => [require.resolveWeak('../global/containers/common/TermsAndCondition')],
  loading: () => <span/>,
  modules: ['TermsAndCondition'],
  });
const TicketBookingForm = Loadable({
  loader: () => import(/* webpackChunkName: "TicketBookingForm" */ '../global/containers/common/TicketBookingForm'),
  webpack: () => [require.resolveWeak('../global/containers/common/TicketBookingForm')],
  loading: () => <span/>,
  modules: ['TicketBookingForm'],
  });
const Tickets = Loadable({
  loader: () => import(/* webpackChunkName: "Tickets" */ '../global/containers/common/Tickets'),
  webpack: () => [require.resolveWeak('../global/containers/common/Tickets')],
  loading: () => <span/>,
  modules: ['Tickets'],
  });
const TimerAndTag = Loadable({
  loader: () => import(/* webpackChunkName: "TimerAndTag" */ '../global/containers/common/TimerAndTag'),
  webpack: () => [require.resolveWeak('../global/containers/common/TimerAndTag')],
  loading: () => <span/>,
  modules: ['TimerAndTag'],
  });
const Tint = Loadable({
  loader: () => import(/* webpackChunkName: "Tint" */ '../global/containers/common/Tint'),
  webpack: () => [require.resolveWeak('../global/containers/common/Tint')],
  loading: () => <span/>,
  modules: ['Tint'],
  });
const TripAdvisor = Loadable({
  loader: () => import(/* webpackChunkName: "TripAdvisor" */ '../global/containers/common/TripAdvisor'),
  webpack: () => [require.resolveWeak('../global/containers/common/TripAdvisor')],
  loading: () => <span/>,
  modules: ['TripAdvisor'],
  });
const TwoColumnSubLayout = Loadable({
  loader: () => import(/* webpackChunkName: "TwoColumnSubLayout" */ '../global/containers/common/TwoColumnSubLayout'),
  webpack: () => [require.resolveWeak('../global/containers/common/TwoColumnSubLayout')],
  loading: () => <span/>,
  modules: ['TwoColumnSubLayout'],
  });
const UsefulApps = Loadable({
  loader: () => import(/* webpackChunkName: "UsefulApps" */ '../global/containers/common/UsefulApps'),
  webpack: () => [require.resolveWeak('../global/containers/common/UsefulApps')],
  loading: () => <span/>,
  modules: ['UsefulApps'],
  });
const WeatherTrend = Loadable({
  loader: () => import(/* webpackChunkName: "WeatherTrend" */ '../global/containers/common/WeatherTrend'),
  webpack: () => [require.resolveWeak('../global/containers/common/WeatherTrend')],
  loading: () => <span/>,
  modules: ['WeatherTrend'],
  });

const components = new Map();
components.set('AddToCalendar', AddToCalendar);
components.set('Article', Article);
components.set('BannerSupergraphic', BannerSupergraphic);
components.set('BoxOverlayImage', BoxOverlayImage);
components.set('BranchesMap', BranchesMap);
components.set('Breadcrumb', Breadcrumb);
components.set('BusinessFacility', BusinessFacility);
components.set('CategoryListing', CategoryListing);
components.set('CollageType1', CollageType1);
components.set('CollageType2', CollageType2);
components.set('CompanyLocations', CompanyLocations);
components.set('ConfigurableTimer', ConfigurableTimer);
components.set('CookieConsent', CookieConsent);
components.set('CurrentWeather', CurrentWeather);
components.set('DayHighlight', DayHighlight);
components.set('DetailedDescription', DetailedDescription);
components.set('DualHeroSlider', DualHeroSlider);
components.set('EditorialGrid', EditorialGrid);
components.set('EditorialText', EditorialText);
components.set('EventDetails', EventDetails);
components.set('ExploreHotels', ExploreHotels);
components.set('ExploreMap', ExploreMap);
components.set('FaqAccordion', FaqAccordion);
components.set('FavoriteSubLayout', FavoriteSubLayout);
components.set('FilteredList', FilteredList);
components.set('Filters', Filters);
components.set('FlexiVisual', FlexiVisual);
components.set('Footer', Footer);
components.set('Form', Form);
components.set('FormCollection', FormCollection);
components.set('GenericMap', GenericMap);
components.set('GlobalSearchSubLayout', GlobalSearchSubLayout);
components.set('HappinessWidget', HappinessWidget);
components.set('Header', Header);
components.set('HeroBannerSupergraphic', HeroBannerSupergraphic);
components.set('HeroCarousel', HeroCarousel);
components.set('Infobox', Infobox);
components.set('ItineraryMap', ItineraryMap);
components.set('ListingSubLayout', ListingSubLayout);
components.set('MarketingMessage', MarketingMessage);
components.set('MediaGallery', MediaGallery);
components.set('MegaNav', MegaNav);
components.set('MultiCardCarousel', MultiCardCarousel);
components.set('NoFavoriteFound', NoFavoriteFound);
components.set('NoSearchResult', NoSearchResult);
components.set('Notification', Notification);
components.set('OperatingHours', OperatingHours);
components.set('OurRecommendation', OurRecommendation);
components.set('PageHeading', PageHeading);
components.set('PillarsCarousel', PillarsCarousel);
components.set('PrivacyPolicy', PrivacyPolicy);
components.set('Quote', Quote);
components.set('QuotesCarousel', QuotesCarousel);
components.set('RegionsMap', RegionsMap);
components.set('RequestForProposal', RequestForProposal);
components.set('ResponsiveCollage', ResponsiveCollage);
components.set('ScheduleData', ScheduleData);
components.set('Search', Search);
components.set('SearchBar', SearchBar);
components.set('SimilarSearch', SimilarSearch);
components.set('SingleSlideCarousel', SingleSlideCarousel);
components.set('Sitemap', Sitemap);
components.set('SmartList', SmartList);
components.set('SocialShare', SocialShare);
components.set('SponsorGrid', SponsorGrid);
components.set('StickyTitle', StickyTitle);
components.set('SubNavigation', SubNavigation);
components.set('TabsWithArticle1', TabsWithArticle1);
components.set('TabsWithCollage', TabsWithCollage);
components.set('TabsWithForm', TabsWithForm);
components.set('TermsAndCondition', TermsAndCondition);
components.set('TicketBookingForm', TicketBookingForm);
components.set('Tickets', Tickets);
components.set('TimerAndTag', TimerAndTag);
components.set('Tint', Tint);
components.set('TripAdvisor', TripAdvisor);
components.set('TwoColumnSubLayout', TwoColumnSubLayout);
components.set('UsefulApps', UsefulApps);
components.set('WeatherTrend', WeatherTrend);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
